export default "__VITE_ASSET__FQYVzSd0__"